import { render } from "./ShiftTemplateManager.vue?vue&type=template&id=4bd0eb8c&scoped=true"
import script from "./ShiftTemplateManager.vue?vue&type=script&lang=js"
export * from "./ShiftTemplateManager.vue?vue&type=script&lang=js"

import "./ShiftTemplateManager.vue?vue&type=style&index=0&id=4bd0eb8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd0eb8c"]])

export default __exports__